import { GeneralTable } from "@/shared/components/ui";
import { useCheckPermissionsArray, useTableFilter, useTableServerSideFiltering } from "@/shared/hooks";
import {
  EstadoProspectoEnum,
  ROUTER_PATHS,
  TABLE_CONSTANTS,
} from "@/shared";
import { IServicioDigital } from "@/shared/interfaces";
import { PermissionsEnum } from "@/auth/interfaces";
import { useNavigate } from "react-router-dom";
import { useGetServicioDigital } from "@/shared/actions/erp/servicio_digital.actions";
import { useTableColumnsServicioDigital } from "./useTableColumnsServicioDigital";

interface TableServicioDigitalProps {
  showCustomActionBtnSpace?: boolean
  enableEditing?: boolean
  estado_prospecto?: EstadoProspectoEnum
}


export default function TableServicioDigital({
}: TableServicioDigitalProps) {

  useCheckPermissionsArray([
    PermissionsEnum.api_view_serviciodigital,
    PermissionsEnum.api_change_serviciodigital
  ]);



  const navigate = useNavigate()


  ///* Hooks
  const {
    columnsServicioDigital
  } = useTableColumnsServicioDigital();

  const {
    pagination,
    // searchTerm,
    // dateBefore,
    // dateAfter,

    setPagination,
  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;


  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { isLoading, data: dataServicioDigital, isRefetching } =
    useGetServicioDigital({
      page: pageIndex + 1,
      ...filterObject,
      filterByState: false,
      pageSize
    });


  const onEdit = (original: IServicioDigital) => {
    console.log(original)
    navigate(`${ROUTER_PATHS.solucionesDigitales.servicios_nav}/editar/${original?.id_servicio_digital}`);
  };




  return (
    <>
      <GeneralTable<IServicioDigital>
        columns={columnsServicioDigital}
        data={dataServicioDigital?.data.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        ///* search
        enableGlobalFilter={false}
        enableSorting={false}
        // onGlobalFilterChange={setGlobalFilter}
        ///* pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={dataServicioDigital?.data?.count}
        ///* filters - server side
        enableManualFiltering={true}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}

        // crud
        canEdit={true}
        enableEditing={true}
        showCustomActionBtnSpace={false}
        onEdit={val=>onEdit(val)}
        actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH_MEDIUM}

      />
    </>

  );



}